import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import IdNameModel from "../../../models/common/IdNameModel";
import { EMAIL_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import { Controller, useForm } from "react-hook-form";
import candidateService from '../../../services/candidate/candidate-service';
import fileUploadService from '../../../services/file-upload-service';
import toasterUtils from "../../../utils/toaster-utils";
import CandidateProfileRequest from "../../../models/candidate/request/CandidateProfileRequest";
import CandidateProfileModel from "../../../models/candidate/response/CandidateProfileModel";
import { FileUploadTypeEnum } from "../../../models/enums/FileUploadTypeEnum";
import fileUtils from "../../../utils/file-utils";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import modalUtils from "../../../utils/modal-utils";
import loaderUtils from "../../../utils/loader-utils";
import ViewResumePopUp from "../../common/view-file/ViewResumeComponent";
import { useHistory } from "react-router";
import { TextField, Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, FormControlLabel, Checkbox, Autocomplete } from "@mui/material";

interface CandidateProfileProps {
    objCandidateProfile: CandidateProfileModel;
    experienceList: IdNameModel[];
    cityList: IdNameModel[];
    designationList: IdNameModel[];
    noticePeriodList: IdNameModel[];
}

const CandidateProfileComponent = (props: CandidateProfileProps) => {
    console.log(props.objCandidateProfile);
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [city] = useState<IdNameModel[]>(props.cityList);
    const [designation] = useState<IdNameModel[]>(props.designationList);
    const [experience] = useState<IdNameModel[]>(props.experienceList);
    const [noticePeriod] = useState<IdNameModel[]>(props.noticePeriodList);
    const [isResumeUploaded, setIsResumeUploaded] = useState<boolean>(false);
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<CandidateProfileRequest>({
        mode: "onChange",
        defaultValues: props.objCandidateProfile
    });

    useEffect(() => {
        clearFile();
        if (props.objCandidateProfile.resumeTitle) {
            setIsResumeUploaded(true);
        }
    }, []);

    const hiddenFileInput: any = React.useRef();
    const browseFileHandler = (event: any) => {
        event.preventDefault();
        hiddenFileInput.current.click();
    };

    const clearFile = () => {
        hiddenFileInput.current.value = "";
    };

    function uploadCandidateResume(e: any): void {
        const data = new FormData();
        data.append("file", e.target.files[0]);
        data.append("fileName", e.target.files[0].name);
        data.append("userId", loggedInUser ? loggedInUser.profileId : "");
        data.append("fileUploadType", FileUploadTypeEnum.CandidateResume.toString());
        modalUtils.showLoader();
        fileUploadService.uploadFile(data).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            setIsResumeUploaded(true);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const downloadCandidateResume = () => {
        if (loggedInUser) {
            modalUtils.showLoader();
            candidateService.downloadCandidateResume(loggedInUser.profileId, FileUploadTypeEnum.CandidateResume.toString()).then((res) => {
                modalUtils.closeModal();
                // const config: GeneralPoupConfig = {
                //     title: "Resume",
                //     content: (
                //         <ViewResumePopUp
                //             responseResume={res}
                //             resumeTitle={props.objCandidateProfile.resumeTitle} />
                //     ),
                //     size: ModalSize.XL,
                //     className: "model-rating-details-badge"
                // };
                // modalUtils.showPopup(config);
                fileUtils.downloadFile(res, props.objCandidateProfile.resumeTitle);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onSubmit = (formData: CandidateProfileRequest) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (isResumeUploaded) {
            modalUtils.showLoader();
            candidateService.saveCandidateProfile(formData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    history.push("/schedule-interview");
                }, 1000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            toasterUtils.showWarning("Please Upload Resume to Save Profile.");
        }
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="cityId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={city.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={city} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="City" size="small" required margin="normal" fullWidth error={!!errors.cityId} helperText={errors.cityId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <Controller name="experienceId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={experience.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={experience} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Experience" size="small" required margin="normal" fullWidth error={!!errors.experienceId} helperText={errors.experienceId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="designationId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={designation.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={designation} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Designation" size="small" required margin="normal" fullWidth error={!!errors.designationId} helperText={errors.designationId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.currentPay}>
                                <TextField type="number" label="Current Pay" size="small" {...register("currentPay", { required: true })} error={!!errors.currentPay}
                                    helperText={errors.currentPay?.message} autoComplete="off" required />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="noticePeriodId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={noticePeriod.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={noticePeriod} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Notice Period" size="small" required margin="normal" fullWidth error={!!errors.noticePeriodId} helperText={errors.noticePeriodId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                                <TextField type="text" label="Mobile Number" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                                    helperText={errors.mobileNumber?.message} autoComplete="off" required />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.emailId}>
                                <TextField type="email" label="Email Address" size="small" {...register("emailId", EMAIL_RULE)} error={!!errors.emailId}
                                    helperText={errors.emailId?.message} autoComplete="off" required />
                            </FormControl>
                        </div>
                        <div className="col-md-6">
                            <Controller name="restrictEmployerToViewProfile" control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox {...field} checked={field.value || false} />
                                        }
                                        label="Keep My Profile Confidential"
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <FormControl fullWidth margin="normal">
                                <InputLabel shrink>Resume {!isResumeUploaded && <span className="required">*</span>}</InputLabel>
                                <Button variant="outlined" component="label" size="small" fullWidth sx={{ mt: 1 }}                                >
                                    Upload Resume
                                    <input type="file" hidden ref={hiddenFileInput} onChange={uploadCandidateResume} accept=".doc,.docx,application/pdf" />
                                </Button>
                                {!isResumeUploaded && (
                                    <FormHelperText error>
                                        Please upload your resume.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        {isResumeUploaded &&
                            <div className="col-md-3 mt-4">
                                <Button variant="contained" color="primary" startIcon={<i className="fa fa-download"></i>} onClick={downloadCandidateResume} size="small"                                >
                                    Download Resume
                                </Button>
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-md-9"></div>
                        <div className="col-md-3  text-end">
                            <Button variant="contained" color="primary" type="submit" disabled={!isValid}>
                                Save Profile
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CandidateProfileComponent;